@if (file) {
  <div class="uploaded-files-list">
    @if (file.preview) {
      <img [ngSrc]="file.preview" [width]="150" [height]="100" [alt]="file.filename" class="upload-image" [sizes]="'100vw, 100vw, 100vw'" priority="low"/>
    }
    @if (file.type === 'image') {
      <img [ngSrc]="file.path!" [width]="150" [height]="100" [sizes]="'100vw, 100vw, 100vw'" [alt]="file.filename" priority="low" class="upload-image" [disableOptimizedSrcset]="file.path!.endsWith('.gif')" />
    }
    @if (file.preview || file.type === 'image') {
      <div class="image-preview-overlay"></div>
    }
    @if (!file.preview && file.type !== 'image') {
      <div class="fileIcons">
        <div class="file-icon-container" [class]="documentService.getDocumentClass(file)">
          <span class="fileIconBase mts-icon mts-icon-filled fs-l lh-base">insert_drive_file</span>
          <div class="file-type">{{ documentService.getDocumentExtension(file) }}</div>
        </div>
      </div>
    }
  </div>
}
